import { takeEvery, put } from "redux-saga/effects";
import {
  CHANGE_ACTIVE_NAV,
  CHANGE_ACTIVE_SCHOOL,
  REHYDRATE_NAV_DATA,
} from "./navmode.type";

import { changeActiveNav, changeActiveSchool } from "redux/navmode.action";

function* watchNavModeChange() {
  yield takeEvery(CHANGE_ACTIVE_NAV, (data: any) => {
    console.log("CHANGED", data);
    const { mode } = data.payload;
    localStorage.setItem("mode", mode);
  });
}

function* watchSchoolSelectionChange() {
  yield takeEvery(CHANGE_ACTIVE_SCHOOL, (data: any) => {
    console.log("SCHOOL CHANGED", data);
    const { school } = data.payload;

    localStorage.setItem("school", JSON.stringify(school));
  });
}

function* watchRehydrate(dispatch: any) {
  yield takeEvery(REHYDRATE_NAV_DATA, rehydrateData);
}

function* rehydrateData() {
  const mode = localStorage.getItem("mode");
  const school = JSON.parse(localStorage.getItem("school"));

  yield put(changeActiveNav(mode));
  yield put(changeActiveSchool(school));
}

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  watchNavModeChange,
  watchSchoolSelectionChange,
  watchRehydrate,
  rehydrateData,
];
